/* DealsLabel - comportements fiche produit
   1. "Guide des tailles" place au-dessus des tailles, restaure apres re-rendu de variante
   2. Prix injecte dans le bouton "Ajouter au panier"
   3. Badges de reassurance injectes sous le bloc code FIRST10
   4. Ligne "En stock, livraison prevue entre le ... et le ..." sous le CTA

   Note: Shopify re-genere le bloc variantes a chaque changement de taille.
   On ne peut donc se fier ni a une reference de conteneur, ni a un observer
   attache au chargement. On revalide en continu, a bas cout.
*/
(function () {
  'use strict';

  var savedLink = null;

  /* ---------- 1. Guide des tailles ---------- */
  function sizeFieldset() {
    var list = document.querySelectorAll('.product-form__input legend.form__label, fieldset legend.form__label');
    for (var i = 0; i < list.length; i++) {
      if (/taille/i.test(list[i].textContent)) return list[i].parentElement;
    }
    return null;
  }

  function placeSizeGuide() {
    var box = sizeFieldset();
    if (!box || !box.parentElement) return;

    var link = document.querySelector('.dl-sizeguide-link');
    if (link) { savedLink = link; } else if (savedLink) { link = savedLink; } else { return; }

    if (link.parentElement === box.parentElement && link.nextElementSibling === box) return;
    box.parentElement.insertBefore(link, box);
  }

  /* ---------- 2. Prix dans le CTA ---------- */
  function currentPrice() {
    var el = document.querySelector('.product__info .price__sale .price-item--sale')
          || document.querySelector('.product__info .price__regular .price-item')
          || document.querySelector('.product__info .price .price-item');
    return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function syncCtaPrice() {
    var btn = document.querySelector('.product-form__submit');
    if (!btn) return;
    var p = currentPrice();
    if (!p) return;
    var span = btn.querySelector('.dl-cta-price');
    if (!span) {
      span = document.createElement('span');
      span.className = 'dl-cta-price';
      btn.appendChild(span);
    }
    if (span.textContent !== p) span.textContent = p;
  }

  /* ---------- 3. Badges de reassurance sous le bloc FIRST10 ---------- */
  var BADGES = [
    {
      title: 'Paiement s\u00e9curis\u00e9',
      sub: 'Visa, Mastercard, American Express, Apple Pay et Klarna.'
    },
    {
      title: 'Livraison offerte',
      sub: '\u00c0 partir de 200\u00a0\u20ac d\u2019achat en Europe.'
    },
    {
      title: 'Retours sous 14 jours',
      sub: 'Retournez facilement votre commande sous 14 jours.'
    }
  ];

  // Le code FIRST10 est injecte par une application : sa position n'est
  // connue qu'au moment de l'execution. On le repere par son texte.
  function first10Block() {
    var info = document.querySelector('.product__info');
    if (!info) return null;

    var all = info.querySelectorAll('div, p, section, aside');
    var deepest = null;
    for (var i = 0; i < all.length; i++) {
      if ((all[i].textContent || '').indexOf('FIRST10') !== -1) deepest = all[i];
    }
    if (!deepest) return null;

    // remonter jusqu'au conteneur du bloc, sans englober le bouton d'achat
    var node = deepest;
    var guard = 0;
    while (node.parentElement && node.parentElement !== info && guard < 6) {
      var p = node.parentElement;
      var t = (p.textContent || '').toUpperCase();
      if (t.indexOf('AJOUTER') !== -1 || t.indexOf('PANIER') !== -1) break;
      node = p;
      guard++;
    }
    return node;
  }

  function badgesAnchor() {
    return first10Block()
        || document.querySelector('.product__info .dl-cta-note')
        || document.querySelector('.product__info .dl-eta');
  }

  function buildBadges() {
    var host = badgesAnchor();
    if (!host || !host.parentNode) return;

    var el = document.querySelector('.dl-badges');
    if (el && el.previousElementSibling === host) return;

    if (!el) {
      el = document.createElement('div');
      el.className = 'dl-badges';
      var html = '';
      for (var i = 0; i < BADGES.length; i++) {
        html += '<div class="dl-badges__item">'
             +    '<div class="dl-badges__body">'
             +      '<p class="dl-badges__title"></p>'
             +      '<p class="dl-badges__sub"></p>'
             +    '</div>'
             +    '<span class="dl-badges__shapes" aria-hidden="true">'
             +      '<span class="dl-badges__shape dl-badges__shape--outline"></span>'
             +      '<span class="dl-badges__shape dl-badges__shape--fill"></span>'
             +      '<span class="dl-badges__shape dl-badges__shape--small"></span>'
             +    '</span>'
             +  '</div>';
      }
      el.innerHTML = html;
      var titles = el.querySelectorAll('.dl-badges__title');
      var subs = el.querySelectorAll('.dl-badges__sub');
      for (var k = 0; k < BADGES.length; k++) {
        titles[k].textContent = BADGES[k].title;
        subs[k].textContent = BADGES[k].sub;
      }
    }

    host.parentNode.insertBefore(el, host.nextSibling);
  }

  /* ---------- 4. Ligne disponibilite + delai de livraison ---------- */
  var JOURS = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
  var MOIS = ['janvier', 'f\u00e9vrier', 'mars', 'avril', 'mai', 'juin',
              'juillet', 'ao\u00fbt', 'septembre', 'octobre', 'novembre', 'd\u00e9cembre'];

  // ajoute n jours ouvres (samedi et dimanche exclus)
  function addBusinessDays(from, n) {
    var d = new Date(from.getTime());
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return d;
  }

  function frDate(d) {
    return JOURS[d.getDay()] + ' ' + d.getDate() + ' ' + MOIS[d.getMonth()];
  }

  function isSoldOut() {
    var btn = document.querySelector('.product-form__submit');
    if (!btn) return false;
    if (btn.disabled) return true;
    return /rupture|sold\s*out|indisponible|\u00e9puis/i.test(btn.textContent || '');
  }

  function buildEta() {
    var el = document.querySelector('.dl-eta');

    // article indisponible dans cette taille : aucun badge affiche
    if (isSoldOut()) {
      if (el && el.parentNode) el.parentNode.removeChild(el);
      return;
    }

    var btns = document.querySelector('.product__info .product-form__buttons')
            || (document.querySelector('.product-form__submit') || {}).parentNode;
    if (!btns || !btns.parentNode) return;

    if (!el) {
      el = document.createElement('p');
      el.className = 'dl-eta';
      btns.parentNode.insertBefore(el, btns.nextSibling);
    } else if (el.previousElementSibling !== btns) {
      btns.parentNode.insertBefore(el, btns.nextSibling);
    }

    // fenetre de livraison : 2 a 5 jours ouvres
    var now = new Date();
    var min = addBusinessDays(now, 2);
    var max = addBusinessDays(now, 5);
    var html = '<span class="dl-eta__dot"></span>En stock, livraison pr\u00e9vue entre le <strong>'
             + frDate(min) + '</strong> et le <strong>' + frDate(max) + '</strong>';

    if (el.innerHTML !== html) el.innerHTML = html;
  }

  /* ---------- Orchestration ---------- */
  function tick() {
    try {
      placeSizeGuide();
      syncCtaPrice();
      buildBadges();
      buildEta();
    } catch (e) { /* ne jamais casser la page */ }
  }

  function burst() {
    var n = 0;
    var t = setInterval(function () {
      n++;
      tick();
      if (n > 12) clearInterval(t);
    }, 60);
  }

  function init() {
    tick();
    setInterval(tick, 500);

    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('.product__info')) burst();
    }, true);

    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('.product-option__label--circle')) burst();
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
